import styled from "styled-components";
import { HXButton } from "../HXButton";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { HXPage } from "../HXDesktopPage";
import { FlexColumnDiv, FlexRowDiv } from "../common.styles";
export const GlobalAdminGlobalOrganizationListViewParent = styled(HXPage) ``;
export const OrganizationTable = styled.table `
    font-size: ${fontSizes.SMALL};
    margin-top: 5px;
    width: 100%;
    border: 2px solid ${colors.black_30};
    border-collapse: collapse;
    & th {
        text-align: center;
    }

    & th,
    td {
        padding: 8px 10px;
        vertical-align: middle;
        text-align: center;
    }

    & tbody tr:nth-child(odd) {
        background-color: ${colors.black_4};
    }
`;
export const Section = styled.div `
    width: 800px;
    margin-bottom: 30px;
`;
export const SectionHeaderWrapper = styled.div `
    display: flex;
    align-items: center;
`;
export const SectionHeader = styled.div `
    font-size: ${fontSizes.LARGE};
`;
export const SectionActionButton = styled(HXButton) `
    display: block;
    margin-left: auto;
    margin-right: 10px;
`;
export const ActionTableCell = styled.td `
    width: 200px;
    text-align: right;
`;
export const Summary = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const SummaryItem = styled(FlexRowDiv) ``;
export const SummaryLabel = styled.div `
    font-weight: bold;
    width: 150px;
`;
export const SummaryValue = styled.div ``;
export const ExpandableRow = styled.tr `
    cursor: pointer;
`;
export const ExpandedDetailsCell = styled.td `
    padding: 16px 16px 16px 60px;
    background-color: #f9f9f9;
`;
export const PatientResultsHeader = styled.div `
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 14px;
`;
export const PatientResultsTable = styled.table `
    width: 100%;
    font-size: 13px;

    thead tr {
        border-bottom: 2px solid #ddd;
    }

    th {
        text-align: center;
        padding: 8px;
        font-weight: 600;
    }

    tbody tr {
        border-bottom: 1px solid #eee;
    }

    td {
        padding: 8px;
        text-align: center;
    }
`;
export const StatusIconCell = styled.td `
    text-align: center;
    font-size: 14px;
`;
export const MagPICell = styled.td `
    font-family: monospace;
    font-size: 12px;
`;
export const NameCell = styled.td `
    min-width: 160px;
`;
export const PhoneCell = styled.td `
    min-width: 110px;
`;
export const CommentsCell = styled.td `
    min-width: 160px;
`;
